import PropTypes from 'prop-types';
import { Component } from 'react';
import { isEqual } from 'underscore';
import styled from 'styled-components';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PREVIEW_IFRAME_NAME = 'hs-preview-iframe';
export const PREVIEW_IFRAME_FORM_NAME = 'hs-preview-iframe-form';
const StyledIframe = styled.iframe.withConfig({
  displayName: "EPPreviewIframe__StyledIframe",
  componentId: "sc-1629vuj-0"
})({
  border: 'none',
  width: '100%',
  height: '100%'
});
const SpinnerContainer = styled.div.withConfig({
  displayName: "EPPreviewIframe__SpinnerContainer",
  componentId: "sc-1629vuj-1"
})(["position:absolute;top:calc(50% - 14px);z-index:-1;"]);
const HiddenForm = styled.form.withConfig({
  displayName: "EPPreviewIframe__HiddenForm",
  componentId: "sc-1629vuj-2"
})({
  display: 'none',
  visibility: 'hidden'
});
class EPPreviewIframe extends Component {
  constructor(props) {
    super(props);
    this.onLoad = this.onLoad.bind(this);
    this.state = {
      isLoading: true
    };
  }
  componentDidMount() {
    const {
      formUrl
    } = this.props;
    if (formUrl) {
      this.submitForm();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      formData,
      formUrl
    } = this.props;
    if (formUrl) {
      if (prevProps.formUrl !== formUrl || !isEqual(prevProps.formData, formData)) {
        this.submitForm();
      }
    } else if (prevProps.formUrl) {
      // Force refresh the iframe when formUrl is removed
      // eslint-disable-next-line no-self-assign
      this.iframeRef.src = this.iframeRef.src;
    }
  }
  submitForm() {
    if (this.formRef) {
      this.formRef.submit();
    }
  }
  onLoad() {
    this.setState({
      isLoading: false
    });
  }
  renderFormInputs() {
    const {
      formData
    } = this.props;
    return Object.keys(formData).map((key, i) => {
      if (typeof formData[key] === 'undefined') return null;
      return /*#__PURE__*/_jsx("input", {
        type: "hidden",
        name: key,
        value: JSON.stringify(formData[key])
      }, i);
    });
  }
  renderForm() {
    const {
      formUrl
    } = this.props;
    if (!formUrl) return null;
    return /*#__PURE__*/_jsx(HiddenForm, {
      ref: ref => this.formRef = ref,
      action: formUrl,
      target: PREVIEW_IFRAME_NAME,
      "data-test-id": PREVIEW_IFRAME_FORM_NAME,
      method: "post",
      children: this.renderFormInputs()
    });
  }
  render() {
    const {
      previewUrl,
      deviceHeader,
      previewIframeNavMarker,
      'data-test-id': dataTestId,
      isLoading: isLoadingProp
    } = this.props;
    const {
      isLoading
    } = this.state;
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100%",
      inlineSize: "100%",
      "data-test-id": dataTestId,
      children: [(isLoadingProp || isLoading) && /*#__PURE__*/_jsx(SpinnerContainer, {
        children: /*#__PURE__*/_jsx(LoadingSpinner, {})
      }), deviceHeader, this.renderForm(), previewIframeNavMarker, /*#__PURE__*/_jsx(StyledIframe, {
        ref: ref => this.iframeRef = ref,
        src: previewUrl,
        onLoad: this.onLoad,
        name: PREVIEW_IFRAME_NAME,
        "data-test-id": PREVIEW_IFRAME_NAME,
        allow: "clipboard-write",
        sandbox: "allow-scripts allow-forms allow-popups allow-modals allow-same-origin allow-popups-to-escape-sandbox"
      })]
    });
  }
}
EPPreviewIframe.propTypes = {
  deviceHeader: PropTypes.node,
  formData: PropTypes.object,
  formUrl: PropTypes.string,
  previewUrl: PropTypes.string.isRequired,
  previewIframeNavMarker: PropTypes.node,
  isLoading: PropTypes.bool
};
EPPreviewIframe.defaultProps = {
  formData: {},
  previewIframeNavMarker: null
};
export default EPPreviewIframe;